import { MODAL_PRICING } from '@components/App/Modal/constants'
import {
  SubscriptionActions,
  selectSubscription,
} from '@store/reducers/subscription'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch, useSelector } from 'react-redux'

import { OpenConfirmation } from '@/store'

const CancelAction = OpenConfirmation({
  label: 'Confirm',
  then: [SubscriptionActions.braintreeCancel()],
  title: 'End subscription?',
  message:
    'You will lose access to all premium features after the paid period ends. You can resubscribe at any time.',
})

export const useSubscription = () => {
  const data = useSelector(selectSubscription)
  const dispatch = useDispatch()

  const onSwitch = () => dispatch(openModal(MODAL_PRICING))

  const onCancel = () => dispatch(CancelAction)
  const onUpdate = () => dispatch(SubscriptionActions.requestBillingPortal())

  const onDownload = (orderId: string) =>
    dispatch(SubscriptionActions.downloadInvoice({ orderId }))

  return { data, onSwitch, onCancel, onDownload, onUpdate }
}
